<script lang="ts">
  export let title: string | undefined;
</script>

<section class="search-group">
  {#if title != undefined}
    <h2>
      {title}
    </h2>
  {/if}
  <slot />
</section>

<style>
  .search-group {
    margin-top: var(--space-5);
  }
  .search-group > h2 {
    margin: var(--space-3) var(--space-3);
  }
</style>
